import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import React, { useState } from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import "./ControlPlantContainer.css";
import ZoneContainer from "./ZoneContainer";
import ZoneDetailsContainer from "./ZoneDetailsContainer";

const floor1 = [
  {
    room: "1A",
    temperature: "27,4",
    energy: 183,
    sets: [
      { set: "l1", lights: [1, 2, 3, 4] },
      { set: "l2", lights: [1, 2, 3, 4] },
      { set: "r1", lights: [1, 2, 3, 4] },
      { set: "r2", lights: [1, 2, 3, 4] },
    ],
  },
  {
    room: "1B",
    temperature: "27,14",
    energy: 190,
    sets: [
      { set: "l1", lights: [1, 2, 3, 4] },
      { set: "l2", lights: [1, 2, 3, 4] },
      { set: "r1", lights: [1, 2, 3, 4] },
      { set: "r2", lights: [1, 2, 3, 4] },
    ],
  },
  {
    room: "1C",
    temperature: "26,8",
    energy: 529,
    sets: [
      { set: "l1", lights: [1, 2, 3, 4] },
      { set: "l2", lights: [1, 2, 3, 4] },
      { set: "r1", lights: [1, 2, 3, 4] },
      { set: "r2", lights: [1, 2, 3, 4] },
    ],
  },
  {
    room: "1D",
    temperature: "27,2",
    energy: 0,
    sets: [
      { set: "l1", lights: [1, 2, 3, 4] },
      { set: "l2", lights: [1, 2, 3, 4] },
      { set: "r1", lights: [1, 2, 3, 4] },
      { set: "r2", lights: [1, 2, 3, 4] },
    ],
  },
];

const floor2 = [
  {
    room: "2A",
    temperature: "26,19",
    energy: 182,
    sets: [
      { set: "l1", lights: [1, 2, 3, 4] },
      { set: "l2", lights: [1, 2, 3, 4] },
      { set: "r1", lights: [1, 2, 3, 4] },
      { set: "r2", lights: [1, 2, 3, 4] },
    ],
  },
  {
    room: "2B",
    temperature: "27,10",
    energy: 193,
    sets: [
      { set: "l1", lights: [1, 2, 3, 4] },
      { set: "l2", lights: [1, 2, 3, 4] },
      { set: "r1", lights: [1, 2, 3, 4] },
      { set: "r2", lights: [1, 2, 3, 4] },
    ],
  },
  {
    room: "2C",
    temperature: "28,12",
    energy: 172,
    sets: [
      { set: "l1", lights: [1, 2, 3, 4] },
      { set: "l2", lights: [1, 2, 3, 4] },
      { set: "r1", lights: [1, 2, 3, 4] },
      { set: "r2", lights: [1, 2, 3, 4] },
    ],
  },
];

const ControlPlantContainer = ({ openControl, setOpenControl }) => {
  const handleClose = () => {
    setOpenControl(false);
  };

  return (
    <Dialog
      open={openControl}
      onClose={handleClose}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "80vw",
            maxHeight: "80vh",
          },
        },
      }}
    >
      <DialogTitle>Building Roma - ERCO Lighting System</DialogTitle>
      <div
        style={{
          paddingRight: "20px",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <DialogTitle>
          Inventory / StoreLink - Rome / Building Roma / ERCO Lighting System
        </DialogTitle>
        <DialogActions>
          <Button>Update Asset</Button>
          <Button>Add item or sensor</Button>
        </DialogActions>
      </div>
      <DialogContent>
        <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
          <div className="floorContainer">
            <div className="floorTitle">
              <p>Light Mapping - Floor1</p>
              <MoreVertIcon />
            </div>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(4, 1fr)",
                gap: "50px",
                padding: "15px 25px",
              }}
            >
              {floor1.map((f, i) => {
                return <ZoneContainer key={i} data={f} />;
              })}
            </div>
            <div
              style={{ borderBottom: "1px solid gray", margin: "0px 25px" }}
            ></div>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(4, 1fr)",
                gap: "50px",
                padding: "15px 25px",
              }}
            >
              {floor1.map((f, i) => {
                return (
                  <ZoneDetailsContainer
                    key={i}
                    room={f.room}
                    temperature={f.temperature}
                    energy={f.energy}
                  />
                );
              })}
            </div>
          </div>
          <div className="floorContainer">
            <div className="floorTitle">
              <p>Light Mapping - Floor2</p>
              <MoreVertIcon />
            </div>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(4, 1fr)",
                gap: "50px",
                padding: "15px 25px",
              }}
            >
              {floor2.map((f, i) => {
                return <ZoneContainer key={i} data={f} />;
              })}
            </div>
            <div
              style={{ borderBottom: "1px solid gray", margin: "0px 25px" }}
            ></div>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(4, 1fr)",
                gap: "50px",
                padding: "15px 25px",
              }}
            >
              {floor2.map((f, i) => {
                return (
                  <ZoneDetailsContainer
                    key={i}
                    room={f.room}
                    temperature={f.temperature}
                    energy={f.energy}
                  />
                );
              })}
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ControlPlantContainer;
